// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconReorder: React.FC = () => {
    return (
        <svg
            width="14px"
            height="15px"
            viewBox="0 0 14 15"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <g id="Homepage-–-Set" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="1-3D-–-Homepage-:-Authenticated"
                    transform="translate(-1182.000000, -1411.000000)"
                    fill="currentColor"
                    fillRule="nonzero"
                >
                    <g transform="translate(34.000000, 1088.000000)">
                        <g transform="translate(0.000000, 304.000000)">
                            <g transform="translate(1136.000000, 0.000000)">
                                <g transform="translate(12.000000, 16.000000)">
                                    <g transform="translate(0.000000, 3.726279)">
                                        <path d="M13.1249996,7.02372094 C12.6418352,7.02372094 12.2499996,7.41500993 12.2499996,7.89872094 C12.2499996,9.34629913 11.0725778,10.5237209 9.62499958,10.5237209 L5.24999958,10.5237209 L5.24999958,9.42997094 C5.24999958,9.17105313 5.09747607,8.93614288 4.86089814,8.830049 C4.62382787,8.72723623 4.34765583,8.76825186 4.15351504,8.94325252 L1.96601504,10.9120025 C1.829023,11.0350494 1.74999958,11.2127838 1.74999958,11.3987209 C1.74999958,11.5846581 1.82905054,11.7618459 1.96705478,11.8865333 L4.15455478,13.8552833 C4.27656233,13.9662989 4.43515617,14.0237209 4.59375,14.0237209 C4.6843124,14.0237209 4.77462906,14.0049221 4.86051553,13.9673378 C5.09687483,13.862393 5.24999958,13.6272366 5.24999958,13.3674709 L5.24999958,12.2737209 L9.625,12.2737209 C12.0372657,12.2737209 14,10.3109866 14,7.89872094 C14,7.41473623 13.6089847,7.02372094 13.125,7.02372094 L13.1249996,7.02372094 Z M4.375,3.52372094 L8.72539079,3.52372094 L8.75,4.61747094 C8.75,4.87638875 8.90252352,5.111299 9.13910186,5.21739288 C9.22578108,5.25457998 9.31601596,5.27372094 9.38164079,5.27372094 C9.54056299,5.27372094 9.69800818,5.21561547 9.82105505,5.10539265 L12.0085551,3.13664265 C12.1707033,3.01239248 12.25,2.83465811 12.25,2.62411173 C12.25,2.41356452 12.1709495,2.26098676 12.0329456,2.13629933 L9.84544563,0.167549331 C9.65275431,-0.00504473939 9.3754065,-0.0477827002 9.13915694,0.0556033443 C8.90312517,0.186087806 8.72539079,0.421025593 8.72539079,0.679970939 L8.75,1.77372094 L4.375,1.77372094 C1.96273434,1.77372094 0,3.73700186 0,6.14872094 C0,6.63243194 0.391835988,7.02372094 0.875,7.02372094 C1.35816401,7.02372094 1.75,6.63243194 1.75,6.14872094 C1.75,4.70223673 2.92851579,3.52372094 4.37500042,3.52372094 L4.375,3.52372094 Z"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconReorder);
